// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — unrecognized.classic.js, новая — unrecognized.cp.js
import { isCp } from 'libs/design';
import * as classic from './unrecognized.classic';
import * as cp from './unrecognized.cp';

export const Unrecognized = isCp ? cp.Unrecognized : classic.Unrecognized;
